import{e as o,g as p,m as e}from"./chunk-HBP5N4FR.js";var t={};p(t,{css:()=>s,default:()=>c});var s,c,_=o(()=>{e();s=`.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__copy {
  margin-left: 0.5rem;
}
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__copy svg path {
  fill: #cacbcc;
  transition: all 200ms;
}
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__copy svg path:hover {
  fill: #1f43f4;
}
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__address {
  position: relative;
  display: flex;
  max-width: 100%;
  overflow: hidden;
  width: auto;
}
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__address span {
  max-width: none;
}
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__address span [class*=left] span,
.dapp-core-component__styles__scResultReceiver .dapp-core-component__styles__address span [class*=right] span {
  font-size: 1rem;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(s));c={scResultReceiver:"dapp-core-component__styles__scResultReceiver",copy:"dapp-core-component__styles__copy",address:"dapp-core-component__styles__address"}});export{s as a,c as b,t as c,_ as d};
//# sourceMappingURL=chunk-ZA2RPPFH.js.map
